import { ChangeDetectionStrategy, Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EditorComponent, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { normalizeLegacyRichText } from 'app/shared/functions/legacy-rich-text.functions';
import { RICH_TEXT_EDITOR_INIT } from './rich-text-editor.config';
import { sanitizeEditorHtml } from 'app/shared/functions/sanitize-html.functions';

@Component({
    selector: 'app-rich-text-editor',
    template: `<editor
        [init]="init"
        [disabled]="isDisabled() || readonly()"
        [ngModel]="value()"
        (ngModelChange)="onEditorChange($event)"
        (onBlur)="onTouched()" />`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EditorComponent, FormsModule],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RichTextEditorComponent), multi: true },
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
    ]
})
export class RichTextEditorComponent implements ControlValueAccessor {
    readonly readonly = input(false);
    readonly init = RICH_TEXT_EDITOR_INIT;
    readonly value = signal<string>('');
    readonly isDisabled = signal(false);

    private onChange: (value: string | null) => void = () => undefined;
    onTouched: () => void = () => undefined;

    writeValue(value: string | null): void {
        this.value.set(normalizeLegacyRichText(value));
    }

    registerOnChange(fn: (value: string | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled.set(isDisabled);
    }

    onEditorChange(html: string): void {
        this.value.set(html);
        this.onChange(sanitizeEditorHtml(html));
    }
}
